import React from "react";
import { Link } from "react-router-dom";
import { getCachedLandingPage } from "../../config/apiConfig";
import "../styles/footer.scss";

const APP_STORE_FALLBACK = "https://apps.apple.com/us/app/mango-tv/id6761795550";
const GOOGLE_PLAY_FALLBACK = "https://play.google.com/store/apps/details?id=com.tvanywhereafrica.mangotv";

/**
 * Footer — Shared site footer
 * Figma: Footers (25460:27041) — 1920×626
 *
 * Sections:
 *   1. Top row: "Download our mobile app" + App Store / Google Play badges
 *   2. Bottom row: LOGO + Terms/Privacy + social icons  (link columns empty in current Figma)
 *   3. Background: decorative SVG grid
 */

const Footer = () => {
  const supportInfo = getCachedLandingPage()?.support_info || {};
  const appStoreUrl = supportInfo.app_store_url || APP_STORE_FALLBACK;
  const googlePlayUrl = supportInfo.google_play_store_url || GOOGLE_PLAY_FALLBACK;

  return (
    <div className="mango-footer-wrapper">
      <div className="mango-footer-bg">
        <img
          src="/assets/footer/footer-bg.svg"
          alt=""
          className="mango-footer-bg__img"
        />
      </div>

      {/* Top: Download CTA */}
      <section className="mango-footer__download">
        <div className="mango-footer__download-left">
          <h2 className="mango-footer__download-title">
            Download our mobile app
          </h2>
        </div>
        <div className="mango-footer__download-right">
          <span className="mango-footer__download-label">Available on</span>
          <div className="mango-footer__download-badges">
            <a
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <img
                src="/assets/footer/app-store.svg"
                alt="Download on the App Store"
                className="mango-footer__download-badge"
              />
            </a>
            <a
              href={googlePlayUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <img
                src="/assets/footer/google-play.svg"
                alt="GET IT ON Google Play"
                className="mango-footer__download-badge mango-footer__download-badge--google-play"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Bottom: Brand + Social */}
      <footer className="mango-footer">
        <div className="mango-footer__brand">
          <div className="mango-footer__brand-info">
            <img
              src="/assets/logo/openplay-logo-color.png"
              alt="OpenPlay"
              className="mango-footer__logo-img"
            />
            <p className="mango-footer__legal">
              <Link to="/terms" className="mango-footer__legal-link">
                Terms &amp; Conditions
              </Link>
              <span className="mango-footer__legal-sep">&nbsp; | &nbsp;</span>
              <Link to="/privacy" className="mango-footer__legal-link">
                Privacy Policy
              </Link>
            </p>
          </div>
          <div className="mango-footer__social">
            <a href="/" className="mango-footer__social-icon" aria-label="Instagram">
              <img src="/assets/footer/icon-instagram.svg" alt="Instagram" />
            </a>
            <a href="/" className="mango-footer__social-icon" aria-label="Twitter">
              <img src="/assets/footer/icon-twitter.svg" alt="Twitter" />
            </a>
            <a href="/" className="mango-footer__social-icon" aria-label="YouTube">
              <img src="/assets/footer/icon-youtube.svg" alt="YouTube" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
